import axios from "axios";
import API_URL from "../Config";

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Cache-Control": "no-cache",
  },
});

apiClient.interceptors.request.use((config) => {
  const authKey = localStorage.getItem("authKey");

  if (authKey) {
    config.headers = config.headers || {};
    config.headers.Authorization = authKey;
  }

  return config;
});

export default apiClient;
